import type { StoreCategory } from "./api";

/** What an online store can sell, in picker order (matches the backend). */
export interface StoreCategoryOption {
  slug: StoreCategory;
  label: string;
  hint: string;
}

export const STORE_CATEGORIES: StoreCategoryOption[] = [
  { slug: "fashion", label: "Fashion", hint: "Clothing, shoes and accessories" },
  { slug: "electronics", label: "Electronics", hint: "Gadgets, audio and devices" },
  { slug: "grocery", label: "Grocery", hint: "Fresh food and pantry staples" },
  { slug: "beauty", label: "Beauty", hint: "Skincare, makeup and body" },
  { slug: "furniture", label: "Furniture", hint: "Living, dining and décor" },
];

export function storeCategoryLabel(slug: string): string {
  return STORE_CATEGORIES.find((c) => c.slug === slug)?.label ?? slug;
}
